import { Fragment } from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonTwo = () => {
    // Get theme from localStorage (default to 'light' if not set)
    const theme = localStorage.getItem("theme") || "light";

    // Define colors for light and dark themes
    const skeletonColors = theme === "dark"
        ? { baseColor: "#23272F", highlightColor: "#3A3F4B" }
        : { baseColor: "#CECECE", highlightColor: "#E8E8E8" };

    return (
        <Fragment>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                <div className="grid grid-cols-12 items-center p-2 gap-y-2 py-0 mt-1.5" key={item}>
                    <div className="col-span-2 justify-start">
                        <Skeleton {...skeletonColors} height={40} width={40} circle={true} />
                    </div>
                    <div className="col-span-10 flex flex-col justify-start">
                        <Skeleton {...skeletonColors} height={10} width={100} />
                        <Skeleton {...skeletonColors} height={10} width={250} />
                    </div>
                    <div className="col-span-10 flex flex-col justify-center items-end">
                        <Skeleton {...skeletonColors} height={10} width={100} />
                        <Skeleton {...skeletonColors} height={10} width={250} />
                    </div>
                    <div className="col-span-2 flex justify-end">
                        <Skeleton {...skeletonColors} height={40} width={40} circle={true} />
                    </div>
                </div>
            ))}
        </Fragment>
    )
}

export default SkeletonTwo